<template>
  <div>
    <div class="side-toolbar " style="">
      <a class="option-box" data-type="guide">
        <img
          src="https://g.csdnimg.cn/side-toolbar/3.0/images/guide.png"
          alt=""
          srcset=""
        />
        <span class="show-txt">新手<br />引导</span>
      </a>

      <a class="option-box" data-type="cs">
        <img
          src="https://g.csdnimg.cn/side-toolbar/3.0/images/kefu.png"
          alt=""
          srcset=""
        />
        <span class="show-txt">客服</span>
      </a>

      <a class="option-box" data-type="report">
        <span class="show-txt" style="display:flex;opacity:100;">举报</span>
      </a>

      <a class="option-box go-top-hide" data-type="gotop">
        <img
          src="https://g.csdnimg.cn/side-toolbar/3.0/images/fanhuidingbucopy.png"
          alt=""
          srcset=""
        />
        <span class="show-txt">返回<br />顶部</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.side-toolbar {
  position: fixed;
  right: 8px;
  bottom: 160px;
  width: 44px;
  z-index: 1999;
}
.side-toolbar {
  bottom: 30px !important;
}
.side-toolbar a.option-box {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  background: #000;
  // -webkit-box-shadow: 0 2px 4px 0 rgb(0 0 0 / 5%);
  // box-shadow: 0 2px 4px 0 rgb(0 0 0 / 5%);
  background-color: #fff;
  text-align: center;
  height: 44px;
  cursor: pointer;
  margin-top: 8px;
}
.side-toolbar a.option-box img {
  display: block;
  width: 24px;
}
.side-toolbar a.option-box .show-txt {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 50%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 12px;
  line-height: 14px;
  color: #999aaa;
  background-color: #fff;
  text-align: center;
  opacity: 0;
  -webkit-transition: opacity 0.3s ease-in-out;
  transition: opacity 0.3s ease-in-out;
}
img {
  border-style: none;
  border: 0;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Core/SideToolBar.vue